import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ClientUser {
  id: string;
  nickname?: string;
  avatar_url?: string;
  roles: string[];
}

interface ClientAuthState {
  token: string | null;
  refreshToken: string | null;
  user: ClientUser | null;
  setAuth: (token: string, refreshToken: string, user: ClientUser) => void;
  clear: () => void;
}

/** C 端账号态。问答与私有历史请求必须携带这里保存的 JWT。 */
export const useClientAuth = create<ClientAuthState>()(
  persist(
    (set) => ({
      token: null,
      refreshToken: null,
      user: null,
      setAuth: (token, refreshToken, user) => set({ token, refreshToken, user }),
      clear: () => set({ token: null, refreshToken: null, user: null }),
    }),
    { name: 'kpqd-client-auth' },
  ),
);
